import { REGEX_PATTERNS } from '../constants/regex.constants'
import type {
    IInrAmountFormatConfig,
    IInrRupeeCompactFormatConfig,
} from '@app/core/models/shiksha-dashboard.model'

export function splitShikshaClientTypeAmountLabel(amountLabel: string): {
    primary: string
    secondary?: string
} {
    const trimmedAmountLabel = amountLabel.trim()
    const amountMatch =
        REGEX_PATTERNS.SHIKSHA_CLIENT_TYPE_AMOUNT_WITH_BRACKETS.exec(trimmedAmountLabel)
    if (amountMatch) {
        return { primary: amountMatch[1].trim(), secondary: amountMatch[2].trim() }
    }
    return { primary: trimmedAmountLabel }
}

export function formatInrAmountByConfig(value: number, config: IInrAmountFormatConfig): string {
    const normalizedValue = Number.isFinite(value) ? value : 0
    if (Math.abs(normalizedValue) >= config.croreThreshold) {
        return `${config.currencyCode} ${(normalizedValue / config.croreDivisor).toFixed(2)} ${config.croreUnit}`
    }
    if (Math.abs(normalizedValue) >= config.lakhThreshold) {
        return `${config.currencyCode} ${(normalizedValue / config.lakhDivisor).toFixed(2)} ${config.lakhUnit}`
    }
    return `${config.currencyCode} ${Math.round(normalizedValue).toLocaleString(config.locale)}`
}

export function formatInrRupeeCompact(value: number, config: IInrRupeeCompactFormatConfig): string {
    const normalizedValue = Number.isFinite(value) ? Math.max(value, 0) : 0
    if (normalizedValue >= config.croreThreshold) {
        return `${config.rupeeSymbol}${(normalizedValue / config.croreDivisor).toFixed(1)} Cr`
    }
    if (normalizedValue >= config.lakhThreshold) {
        return `${config.rupeeSymbol}${(normalizedValue / config.lakhDivisor).toFixed(1)} L`
    }
    return `${config.rupeeSymbol}${Math.round(normalizedValue).toLocaleString(config.locale)}`
}

export class FormatHelper {
    static getOrdinalSuffix(number: number): string {
        const lastDigit = number % 10
        const lastTwoDigits = number % 100

        if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
            return 'th'
        }

        switch (lastDigit) {
            case 1:
                return 'st'
            case 2:
                return 'nd'
            case 3:
                return 'rd'
            default:
                return 'th'
        }
    }

    static formatCurrencyWithSpace(amount: string): string {
        if (!amount || amount === '-') {
            return amount
        }

        const rupeeSymbol = '₹'
        if (amount.startsWith(rupeeSymbol)) {
            return `${rupeeSymbol} ${amount.substring(1).trim()}`
        }

        return amount
    }
}
